import SoundCloudPlayer from '@rsa-digital/evo-shared-components/components/SoundCloudPlayer';
import { graphql } from 'gatsby';
import React from 'react';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { CsSoundCloudPlayer } from 'types/contentStack';

type SoundCloudPlayerBlock = {
  soundcloud_player: {
    soundcloud_player: [CsSoundCloudPlayer];
  };
};

const SoundCloudPlayerComponent: React.FC<SoundCloudPlayerBlock> = ({
  soundcloud_player,
}) => {
  const soundcloudPlayer = unwrapSingleton(soundcloud_player.soundcloud_player);

  return (
    <div data-cy={`SoundCloudPlayer-${soundcloudPlayer?.url}`}>
      <SoundCloudPlayer
        url={soundcloudPlayer?.url ?? ''}
        playcount={soundcloudPlayer?.playcount}
        shareable={soundcloudPlayer?.playcount}
        showArtwork={soundcloudPlayer?.show_artwork}
      />
    </div>
  );
};

export default React.memo(SoundCloudPlayerComponent);

export const query = graphql`
  fragment SoundCloudPlayerBlock on cs__soundcloud_player_block {
    soundcloud_player {
      ...SoundCloudPlayer
    }
  }
`;
